import {Route, Routes} from "react-router-dom";
import {Layout} from "./layout/Layout.tsx";
import {SparePartsPage} from "./SparePartsPage/SparePartsPage.tsx";
import {SearchPage} from "./SearchPage/SearchPage.tsx";
import {CartPage} from "./CartPage/CartPage.tsx";
import {PartPage} from "./PartPage/PartPage.tsx";
import {OrderPage} from "./OrderPage/OrderPage.tsx";
import {CatalogPage} from "./CatalogPage/CatalogPage.tsx";
import {About} from "./static/Content/About.tsx";
import {Vacancy} from "./static/Content/Vacancy.tsx";
import {Profile} from './Profile/Profile.tsx';
import ProductSparePartsPage from './SparePartsPage/ProductSparePartsPage.tsx';
import {IndexPage} from "./IndexPage/IndexPage.tsx";
import DeliveryAndPaymentPage from "./static/DeliveryAndPayment/DeliveryAndPaymentPage";
import BonusProgramRegulationPage from "./static/BonusProgram/BonusProgramRegulationPage";
import PrivacyPage from "./static/Privacy/PrivacyPage";
import ForCompanyPage from "./static/ForCompany/ForCompanyPage";
import GuaranteePage from "./static/Guarantee/GuaranteePage";
import {ContactsPage} from "./static/Contacts/ContactsPage.tsx";
import {RefundPage} from "@/pages/Refund/RefundPage.tsx";
import {SearchVehicleByVinPage} from "./SearchVehicle/SearchVehicleByVinPage/SearchVehicleByVinPage.tsx";
import {SearchVehicleByParamsPage} from "./SearchVehicle/SearchVehicleByParamsPage/SearchVehicleByParamsPage.tsx";
import {SearchVehicleWithNamePage} from "./SearchVehicle/SearchVehicleWithNamePage/SearchVehicleWithNamePage.tsx";
import {ForSuppliers} from "./static/ForSuppliers/ForSuppliers.tsx";
import {ForOwners} from "./static/ForOwners/ForOwners.tsx";

export const AppRoutes: React.FC = () => {
    return (
        <Layout>
            <Routes>
                <Route path="/" element={<IndexPage/>}/>
                <Route path="/cart" element={<CartPage/>}/>
                <Route path="/search" element={<SearchPage/>}/>
                <Route path="/catalog" element={<CatalogPage/>}/>
                <Route path="/m/:hash" element={<OrderPage/>}/>
                <Route path="/profile" element={<Profile/>}/>
                <Route path="/profile/:page" element={<Profile/>}/>
                <Route path="/parts/:categorySlug/:brandSlug/:modelSlug/:bodyNumberOrEngineNumber"
                       element={<PartPage/>}/>
                <Route path="/parts/:categorySlug/:brandSlug/:modelSlug" element={<PartPage/>}/>
                <Route path="/parts/:categorySlug/:brandSlug" element={<PartPage/>}/>
                <Route path="/spares/:brandSlug/:article" element={<SparePartsPage/>}/>
                <Route path="/part/*" element={<ProductSparePartsPage/>}/>
                <Route path="/refund" element={<RefundPage/>}/>
                {/* Страница поиска автомобиля */}
                <Route path="/search-vehicle" element={<SearchVehicleByVinPage/>}/>
                <Route path="/search-vehicles" element={<SearchVehicleByParamsPage/>}/>
                <Route path="/search-vehicle-with-name" element={<SearchVehicleWithNamePage/>}/>
                {/* Статические страницы */}
                <Route path="/about" element={<About/>}/>
                <Route path="/vacancy" element={<Vacancy/>}/>
                <Route path="/deliveryandpayment" element={<DeliveryAndPaymentPage/>}/>
                <Route path="/for_company" element={<ForCompanyPage/>}/>
                <Route path="/guarantee" element={<GuaranteePage/>}/>
                <Route path="/contacts" element={<ContactsPage/>}/>
                <Route path="/bonus" element={<BonusProgramRegulationPage/>}/>
                <Route path="/privacy" element={<PrivacyPage/>}/>
                <Route path="/for_suppliers" element={<ForSuppliers/>}/>
                <Route path="/for_owners" element={<ForOwners/>}/>
            </Routes>
        </Layout>
    );
};
